<template>
  <div class="zj-form-container">
    <el-container>
      <zj-layout-main>
        <el-form
          ref="form"
          :model="data"
          :rules="rules"
          label-width="80px"
          style="width: 100%"
        >
          <el-form-item label="配置值" prop="UValue">
            <el-input
              v-model="data.UValue"
              type="textarea"
              :rows="20"
              clearable
            ></el-input>
          </el-form-item>
        </el-form>
      </zj-layout-main>
      <el-footer style="text-align: center">
        <!-- <el-button type="primary" @click="JsonFormat()">JSON格式化</el-button> -->
        <el-button type="primary" @click="OnConfirm()">保存</el-button>
        <el-button @click="OnCancel">取消</el-button>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import ZJApp from "../../../../../app";
import MyApis from "../../../apis";
export default {
  name: "UniformConfigCustomInfo",
  props: {
    query: {
      default: () => ({}),
      type: Object,
    },
    SysConfigArr: {
      default: () => [],
      type: Array,
    },
  },
  data() {
    return {
      data: {
        SysCode: "",
        Ukey: "",
        ConfigId: "",
        Description: "",
        UValue: {},
      },

      rules: {
        UValue: [{ required: true, message: "请输入配置值", trigger: "blur" }],
      },
      preValue: null,
      currentValue: null,
    };
  },
  created() {
    // this.data = this.query.SelectedSys;
    // debugger;
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
  watch: {
    "query.SelectedSys": {
      // eslint-disable-next-line no-unused-vars
      handler: function(val, oldVal) {
        (this.data = { UValue: null }), this.init();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    init() {
      this.data.ConfigId = this.query.SelectedSys.SysId;
      this.data.ClientCode = this.query.SelectedSys.ClientCode;
      this.data.SysCode = this.query.SysCode;
      this.data.Description = this.query.SelectedSys.Description;
      this.getConfigItemInfo();
    },
    //获取配置明细
    getConfigItemInfo() {
      let searchInfo = {
        ConfigId: this.query.SelectedSys.SysId,
      };
      new MyApis.UniformConfigApi()
        .GetDataById(searchInfo)
        .then((r) => {
          r = r.data.Data;
          if (r) {
            this.query.type = "edit";
            this.data = r;
            this.preValue = this.data.UValue;
          } else {
            this.query.type = "add";
          }
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    OnConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.saveData();
        } else {
          return false;
        }
      });
    },
    OnCancel() {
      this.$emit("clickCancel", false);
    },
    saveData() {
      // this.data.UValue = JSON.stringify(this.data.UValue);
      if (this.query.type == "edit") {
        this.data.Creater = this.query.SelectedSys.Creater;
        this.data.CreateTime = this.query.SelectedSys.CreateTime;
        this.data.ModifyTime = new Date();
        this.data.Modifier = ZJApp.ZJUser.current.UserName;
        this.data.Validity = 1;
        this.data.UKeyType = 3;
        this.data.ClientVersion = "Alpha";
        this.data.UKey =
          this.query.SelectedSys.UKey == undefined
            ? this.query.SelectedSys.SysCode
            : this.query.SelectedSys.UKey;
        this.data.UKeyName =
          this.query.SelectedSys.UKeyName == undefined
            ? this.query.SelectedSys.SysName
            : this.query.SelectedSys.UKeyName;
        this.currentValue = this.data.UValue;
        new MyApis.UniformConfigApi()
          .UpdateConfig(this.data)
          .then((r) => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！",
            });
            this.logInfo.ActionName = "配置项自定义子项修改";
            this.logInfo.LogMessage = r
              ? "配置项自定义子项修改成功"
              : "配置项自定义子项修改失败";
            this.logInfo.ModuleName = "配置管理";
            this.logInfo.PageName = "配置项子项详情";
            this.logInfo.PreValue = this.preValue;
            this.logInfo.CurrentValue = this.currentValue;
            this.addOperationLog();
            this.$emit("clickCancel", r);
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      } else {
        // 增加
        let formObj = {
          Creater: ZJApp.ZJUser.current.UserName,
          CreateTime: new Date(),
          Modifier: ZJApp.ZJUser.current.UserName,
          ModifyTime: new Date(),
          Validity: 1, //新增编辑是1，删除是0
          UKeyType: 3, //自定义格式添加
          ClientVersion: "Alpha", //默认alpha版本，兼容基准数据
        };
        this.currentValue = this.data.UValue;
        this.data.UKey = this.query.SelectedSys.SysCode;
        this.data.UKeyName = this.query.SelectedSys.SysName;
        let formAll = Object.assign(formObj, this.data);
        formAll = JSON.stringify(formAll);
        formAll = JSON.parse(formAll);
        new MyApis.UniformConfigApi()
          .AddConfig(formAll)
          .then((r) => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！",
            });
            this.logInfo.ActionName = "配置项自定义子项添加";
            this.logInfo.LogMessage = r
              ? "配置项自定义子项添加成功"
              : "配置项自定义子项添加失败";
            this.logInfo.ModuleName = "配置管理";
            this.logInfo.PageName = "配置项子项详情";
            this.logInfo.PreValue = this.preValue;
            this.logInfo.CurrentValue = this.currentValue;
            this.addOperationLog();
            this.$emit("clickCancel", r);
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    JsonFormat() {
      this.data.UValue = JSON.stringify(this.data.UValue, null, 4);
    },
  },
};
</script>

<style></style>
